module.exports = __webpack_public_path__ + "img/user.1fe01699.svg";